import { render, staticRenderFns } from "./activity-bar.vue?vue&type=template&id=10a442cc&scoped=true&"
import script from "./activity-bar.vue?vue&type=script&lang=js&"
export * from "./activity-bar.vue?vue&type=script&lang=js&"
import style0 from "./activity-bar.vue?vue&type=style&index=0&id=10a442cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a442cc",
  null
  
)

export default component.exports